class EbsFeedBackRequestDto {
  /** EBS系统批次表处理ID */
  batchId = "";

  /** 各系统传入EBS系统时的extBatchId. */
  extBatchId = "";

  /** 各系统传入EBS的接口编码, 依据双方的接口卡确定的 */
  interfaceCode = "";

  /** 外系统行记录Id的错误信息 */
  interfaceLines = [];

  /** 处理信息 */
  processMessage = "";

  /** 处理结果状态。E(验证错误)/S(处理成功) */
  processStatus = "";

  /** EBS系统收到外系统的extBatchId这批数据的接收日期 */
  receivedDate = "";

  /** 来源系统编码 */
  sourceSystem = "";
}

class EbsFeedBackResponseDto {
  /** EBS系统批次表处理ID */
  batchId = "";

  /** 返回信息 */
  returnMessage = "";

  /** 反馈报文接收状态，S:成功，E：错误 */
  returnStatus = "";
}

class EbsRequestRecordLogResponseDto {
  /** EBS系统批次表处理ID */
  batchId = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** ebs接口名称 */
  ebsApiCode = "";

  /** ebs处理状态:0:处理中 1:成功 2:失败 */
  ebsDealStatus = undefined;

  /** 各系统传入EBS系统时的批次号 */
  extBatchId = "";

  /** feedback请求地址 */
  feedbackRequestUrl = "";

  /** feedback请求快照 */
  feedbackSnapshot = "";

  /** 主键id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 请求记录表id */
  recordId = undefined;

  /** 请求id */
  requestId = "";

  /** json请求快照 */
  requestSnapshot = "";

  /** 请求地址 */
  requestUrl = "";

  /** json返回快照 */
  responseSnapshot = "";

  /** 来源系统 */
  sourceSystemCode = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class InterfaceLines {
  /** 由EBS将原来外系统传入extBatchId返回给外系统 */
  extBatchId = "";

  /** 由EBS将原来外系统传入extLineId返回给外系统 */
  extLineId = "";

  /** EBS接口头ID,用于追溯 */
  ifaceHeaderId = "";

  /** EBS接口行ID,用于追溯 */
  ifaceLineId = "";

  /** 每一行的错误消息显示在此信息. */
  processMessage = "";
}

class OpenApiConfigRequestDto {
  /** api编号 */
  apiCode = "";

  /** api请求方式: GET，POST，PUT，DELETE等 */
  apiMode = "";

  /** api名称 */
  apiName = "";

  /** api地址 */
  apiUrl = "";

  /** api版本 */
  apiVersion = "";

  /** 是否需要鉴权，1-是，0-否 */
  authenticationFlag = undefined;

  /** id */
  id = undefined;

  /** 报文协议: json、yaml、xml、customize等 */
  messageProtocol = "";

  /** 通信协议: Restful、MQ、Websocket、SDK等 */
  protocol = "";

  /** 请求头信息 */
  requestHeader = undefined;

  /** 应答头信息 */
  responseHeader = undefined;

  /** 系统编号 */
  systemCode = "";
}

class OpenApiConfigResponseDto {
  /** api编号 */
  apiCode = "";

  /** api请求方式: GET，POST，PUT，DELETE等 */
  apiMode = "";

  /** api名称 */
  apiName = "";

  /** api地址 */
  apiUrl = "";

  /** api版本 */
  apiVersion = "";

  /** 是否需要鉴权，1-是，0-否 */
  authenticationFlag = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 报文协议: json、yaml、xml、customize等 */
  messageProtocol = "";

  /** 通信协议: Restful、MQ、Websocket、SDK等 */
  protocol = "";

  /** 请求头信息 */
  requestHeader = "";

  /** 请求头信息 */
  requestHeaderToJson = undefined;

  /** 应答头信息 */
  responseHeader = "";

  /** 应答头信息 */
  responseHeaderToJson = undefined;

  /** 系统编号 */
  systemCode = "";

  /** 系统名称 */
  systemName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class RequestDto {
  /** api编号 */
  apiCode = "";

  /** api版本  */
  apiVersion = "";

  /** 批次ID 来源系统和目标系统请求的唯一标识 */
  batchId = "";

  /** 请求内容,如果是文件，需BASE64编码转成字符串 */
  body = "";

  /** 业务单据号 */
  businessNo = "";

  /** 请求头变量，比如动态值:时间戳、body MD5值等，静态值可通过api配置表配置 */
  headVariable = undefined;

  /** 请求内容是否文件，不传默认为false */
  isFile = false;

  /** 是否同步，不传默认为false */
  isSync = false;

  /** 参数变量 */
  paramVariable = undefined;

  /** 路径变量 比如请求url:erp.rantion.com/{sku}/info 需传sku的键值对 */
  pathVariable = undefined;

  /** 请求流水id */
  requestId = "";

  /** 来源系统编号 */
  sourceSystemCode = "";

  /** 目标系统编号 */
  targetSystemCode = "";
}

class RequestRecordLogResponseDto {
  /** api编码 */
  apiCode = "";

  /** api编码 */
  apiName = "";

  /** 批次ID */
  batchId = "";

  /** 业务单据号 */
  businessNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 错误信息 */
  errorMsg = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 父请求流水id */
  parentRequestId = "";

  /** 请求流水id */
  requestId = "";

  /** 请求数据 */
  requestSnapshot = "";

  /** 请求状态 0:处理中 10:处理成功 20:处理失败 30:已重发 40:已忽略 */
  requestStatus = undefined;

  /** 请求地址 */
  requestUrl = "";

  /** 响应数据 */
  responseData = "";

  /** 是否重试 0:否 1:是 */
  retryFlag = undefined;

  /** 来源系统编号 */
  sourceSystemCode = "";

  /** 目标系统编号 */
  targetSystemCode = "";

  /** 链路跟踪id */
  traceId = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new IPage();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class SystemConfigRequestDto {
  /** 域名url */
  domainUrl = "";

  /** id */
  id = undefined;

  /** 应答状态模板 */
  responseStatusTemplate = undefined;

  /** 系统编号 */
  systemCode = "";

  /** 系统名称 */
  systemName = "";
}

class SystemConfigResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 域名url */
  domainUrl = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 应答状态模板 */
  responseStatusTemplate = "";

  /** 应答状态模板 */
  responseStatusTemplateToJson = undefined;

  /** 系统编号 */
  systemCode = "";

  /** 系统名称 */
  systemName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class TripartiteSystemAuthRequestDto {
  /** 授权接口编号 */
  apiCode = "";

  /** 授权参数 */
  authParameters = undefined;

  /** 授权类型:client_credentials,authorization_code, implicit_grant或者自定义等 */
  grantType = "";

  /** id */
  id = undefined;

  /** 系统编号 */
  systemCode = "";
}

class TripartiteSystemAuthResponseDto {
  /** 令牌 */
  accessToken = "";

  /** 授权接口编号 */
  apiCode = "";

  /** 令牌有效时间 */
  atEffectiveTime = undefined;

  /** 授权参数 */
  authParameters = "";

  /** 授权参数 */
  authParametersToJson = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 授权类型:client_credentials,authorization_code, implicit_grant或者自定义等 */
  grantType = "";

  /** id */
  id = undefined;

  /** 最新刷新令牌时间 */
  lastAuthTime = "";

  /** 最新授权令牌时间 */
  lastRefreshTime = "";

  /** 版本号 */
  lockVersion = undefined;

  /** 刷新令牌 */
  refreshToken = "";

  /** 刷新令牌有效时间 */
  rtEffectiveTime = undefined;

  /** 系统编号 */
  systemCode = "";

  /** 系统名称 */
  systemName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

export const bus = {
  EbsFeedBackRequestDto,
  EbsFeedBackResponseDto,
  EbsRequestRecordLogResponseDto,
  IPage,
  InterfaceLines,
  OpenApiConfigRequestDto,
  OpenApiConfigResponseDto,
  RequestDto,
  RequestRecordLogResponseDto,
  Response,
  ResponseDto,
  SystemConfigRequestDto,
  SystemConfigResponseDto,
  TripartiteSystemAuthRequestDto,
  TripartiteSystemAuthResponseDto,
};
